import { StoryLineListType } from '@/types/cms/Storylines'
import styles from './StorylineListBulleted.module.scss'
import ArticleDetailDefault from '@/elements/widgets/Article/ArticleDetailDefault'
import AppContext from '@/types/context'

export default function StorylineListBulleted({
  item,
  context,
}: {
  readonly item: { model: StoryLineListType } | any
  readonly context: AppContext
}) {
  return (
    <ul className={styles.ul}>
      {item.model.related?.map((child: any) => (
        <li key={child.id}>
          <ArticleDetailDefault
            key={child.id}
            item={{ items: [{ model: child, type: child.type, id: child.id }] }}
            context={context}
          />
        </li>
      ))}
    </ul>
  )
}
